const resetI18n = {
  "fr": {
    "title": "Nouveau mot de passe",
    "subtitle": "Choisis un nouveau mot de passe.",
    "form": {
      "password": "Nouveau mot de passe",
      "confirm": "Confirmation",
      "submit": "Mettre à jour",
      "loading": "Mise à jour…"
    },
    "success": "Mot de passe mis à jour. Tu peux te reconnecter.",
    "back": "Retour à la connexion",
    "errors": {
      "len": "Le mot de passe doit contenir au moins 6 caractères.",
      "match": "Les mots de passe ne correspondent pas.",
      "invalid": "Lien invalide ou expiré."
    }
  },
  "en": {
    "title": "New password",
    "subtitle": "Choose a new password.",
    "form": {
      "password": "New password",
      "confirm": "Confirm password",
      "submit": "Update",
      "loading": "Updating…"
    },
    "success": "Password updated. You can now sign in.",
    "back": "Back to sign in",
    "errors": {
      "len": "Password must be at least 6 characters.",
      "match": "Passwords do not match.",
      "invalid": "Invalid or expired link."
    }
  },
  "pl": {
    "title": "Nowe hasło",
    "subtitle": "Wybierz nowe hasło.",
    "form": {
      "password": "Nowe hasło",
      "confirm": "Potwierdź hasło",
      "submit": "Zaktualizuj",
      "loading": "Aktualizowanie…"
    },
    "success": "Hasło zaktualizowane. Możesz się zalogować.",
    "back": "Powrót do logowania",
    "errors": {
      "len": "Hasło musi mieć co najmniej 6 znaków.",
      "match": "Hasła nie są takie same.",
      "invalid": "Nieprawidłowy lub wygasły link."
    }
  },
  "es": {
    "title": "Nueva contraseña",
    "subtitle": "Elige una nueva contraseña.",
    "form": {
      "password": "Nueva contraseña",
      "confirm": "Confirmación",
      "submit": "Actualizar",
      "loading": "Actualizando…"
    },
    "success": "Contraseña actualizada. Ya puedes iniciar sesión.",
    "back": "Volver a iniciar sesión",
    "errors": {
      "len": "La contraseña debe tener al menos 6 caracteres.",
      "match": "Las contraseñas no coinciden.",
      "invalid": "Enlace inválido o caducado."
    }
  },
  "it": {
    "title": "Nuova password",
    "subtitle": "Scegli una nuova password.",
    "form": {
      "password": "Nuova password",
      "confirm": "Conferma la password",
      "submit": "Aggiornamento",
      "loading": "Aggiornamento..."
    },
    "success": "Password aggiornata. Ora puoi firmare.",
    "back": "Torna a firmare",
    "errors": {
      "len": "La password deve essere di almeno 6 caratteri.",
      "match": "Le password non corrispondono.",
      "invalid": "link non valido o scaduto."
    }
  },
  "de": {
    "title": "Neues Passwort",
    "subtitle": "Wählen Sie ein neues Passwort.",
    "form": {
      "password": "Neues Passwort",
      "confirm": "Passwort bestätigen",
      "submit": "Aktualisierung",
      "loading": "Aktualisierung..."
    },
    "success": "Passwort aktualisiert. Sie können sich jetzt anmelden.",
    "back": "Zurück zur Anmeldung",
    "errors": {
      "len": "Das Passwort muss mindestens 6 Zeichen umfassen.",
      "match": "Passwörter passen nicht zusammen.",
      "invalid": "Ungültiger oder abgelaufener Link."
    }
  },
  "pt": {
    "title": "Nova senha",
    "subtitle": "Escolha uma nova senha.",
    "form": {
      "password": "Nova senha",
      "confirm": "Confirmar senha",
      "submit": "Atualizar",
      "loading": "Actualizando..."
    },
    "success": "Senha actualizada. Agora podes assinar.",
    "back": "Voltar para iniciar sessão",
    "errors": {
      "len": "A senha deve ter pelo menos 6 caracteres.",
      "match": "As senhas não correspondem.",
      "invalid": "Ligação inválida ou expirada."
    }
  },
  "cs": {
    "title": "Nové heslo",
    "subtitle": "Vyberte si nové heslo.",
    "form": {
      "password": "Nové heslo",
      "confirm": "Potvrdit heslo",
      "submit": "Aktualizovat",
      "loading": "Aktualizace..."
    },
    "success": "Heslo aktualizováno. Můžete se zapsat.",
    "back": "Zpět k přihlášení",
    "errors": {
      "len": "Heslo musí mít alespoň 6 znaků.",
      "match": "Hesla se neshodují.",
      "invalid": "Neplatné nebo prošlé spojení."
    }
  },
  "nl": {
    "title": "Nieuw wachtwoord",
    "subtitle": "Kies een nieuw wachtwoord.",
    "form": {
      "password": "Nieuw wachtwoord",
      "confirm": "Wachtwoord bevestigen",
      "submit": "Bijwerken",
      "loading": "Bijwerken..."
    },
    "success": "Wachtwoord bijgewerkt. Je kunt je nu aanmelden.",
    "back": "Terug om in te tekenen",
    "errors": {
      "len": "Wachtwoord moet minstens 6 tekens zijn.",
      "match": "Wachtwoorden komen niet overeen.",
      "invalid": "Ongeldige of verlopen koppeling."
    }
  }
};

export default resetI18n;
